import React         from 'react';
import { Component } from 'react';
import moment        from 'moment-timezone';
import _             from 'lodash';
import Utils         from '../../Utils/Utility';

export default class ChartHolder extends Component {

    constructor(props){
        super(props);
        this.state = {
            chartOrderData : {},
            chartSalesData : {}
        };

        this.drawCharts = this.drawCharts.bind(this);

        let timeZone    = localStorage.getItem("timeZone");
        moment.tz.setDefault(timeZone);
    }

    componentWillMount() {
        this.setState({
            chartOrderData : this.props.chartOrderData,
            chartSalesData : this.props.chartSalesData
        },
        () => {
            this.drawCharts();
        });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            chartOrderData : nextProps.chartOrderData,
            chartSalesData : nextProps.chartSalesData
        });
    }

    componentDidMount(){
        if ((typeof this.props.google === 'undefined') || (typeof this.props.google.visualization === 'undefined')) {
            this.props.google.charts.load('current', {packages: ['corechart','table','bar']});
            this.props.google.charts.setOnLoadCallback(this.drawCharts);
        }
    }

    componentDidUpdate(prevProps, prevState){
        this.drawCharts();
    }

    render(){
        return (
			<div className="">
                <div className="row">
                    <div className="col-md-12">
                        <h2>SALES</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div id = "chart_div2"></div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <h2>ORDER COUNT</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div id = "chart_div1"></div>
                    </div>
                </div>
            </div>
        );
    }

    genDataRows(chartData){
        return _.values(chartData).map( data => {
            return [ data['date'], data['Delivery'], data['PickUp'],data['DineIn'] ];
        });
    }

    drawCharts(){
        this.drawStacked();
        this.drawSalesChart();
    }

    drawStacked() {

        if(Utils.isEmptyObj(this.state.chartOrderData))
            return;

       let data = new this.props.google.visualization.DataTable();
       data.addColumn('date', 'Date');
       data.addColumn('number', 'Delivery');
       data.addColumn('number', 'PickUp');
       data.addColumn('number', 'DineIn');

       data.addRows(this.genDataRows(this.state.chartOrderData));

      let options = {
        title     : 'Delivery, PickUp & DineIn Order Count',
        isStacked : true,
        width     : '100%',
        height    : '100%',
        chartArea : {top : 40,width : "90%"},
        legend    : {position : 'top', alignment:'end'},
        bar       : {groupWidth : "20%"},
        hAxis     : {
            title     : 'Date',
            format    : 'M/d/yy',
            gridlines : {count : 8}
        },

        vAxis : {
            title    : 'Total Order',
            format   : '#,###',
            minValue : 0,
            maxValue : 4
        }
      };

      let chart = new this.props.google.visualization.ColumnChart(document.getElementById('chart_div1'));
      chart.draw(data, options);
    }

    drawSalesChart(){

        if(Utils.isEmptyObj(this.state.chartSalesData))
            return;

       // console.log("Z:"+moment().format('Z').split(':')[0]);
       let t = moment().format('Z').split(':')[0];
       let data = new this.props.google.visualization.DataTable();
       data.addColumn('date', 'Date');
       data.addColumn('number', 'Delivery Sales(Paid Amount)');
       data.addColumn('number', 'PickUp Sales(Paid Amount)');
       data.addColumn('number', 'DineIn Sales(Paid Amount)');

      data.addRows(this.genDataRows(this.state.chartSalesData));

/*      let dateFormatter = new google.visualization.DateFormat(*/
          //{timeZone:parseInt(moment().format('Z').split(':')[0])}
      //);
      /*dateFormatter.format(data,0);*/

      let formatter = new google.visualization.NumberFormat(
          {prefix: '$'});
          formatter.format(data, 1);
          formatter.format(data, 2);

      let options = {
        title         : 'Delivery, PickUp & DineIn Sales',
        width         : '100%',
        height        : '100%',
        chartArea     : {top : 40,width : "90%"},
        isStacked     : true,
        legend        : {position : 'top', alignment:'end'},
        bar           : {groupWidth : "20%"},
        hAxis         : {
            title     : 'Date',
            format    : 'M/d/yy',
            gridlines : {count    : 8}
        },
        vAxis         : {
            minValue  : 0,
            maxValue  : 55,
            title     : 'Total Amount ($)'
        }
      };

      let chart = new this.props.google.visualization.ColumnChart(document.getElementById('chart_div2'));
      chart.draw(data, options);
    }
}



// WEBPACK FOOTER //
// src/components/visualization/chart-holder.js